import Vue from 'vue';
import api from '../utils/api';

const token = localStorage.getItem('token');
if (token) {
    api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
}
Vue.prototype.$http = api;
Vue.config.productionTip = false;
Vue.config.performance = true;

export default Vue